<template>
  <div id="main-wrapper">
    <NavbarDark />
    <section class="gray-simple">
      <div class="container">
        <div class="row m-0">
          <div class="short_wraping">
            <div class="row align-items-center">
              <!-- <div class="col-lg-2 col-md-6 col-sm-12  col-sm-6">
                                <ul class="shorting_grid">
                                    <li>
                                        <router-link to="/grid-layout-with-sidebar">
                                            <span class="svg-icon text-muted-2 svg-icon-2hx">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor"/>
                                                    <rect opacity="0.3" x="13" y="2" width="9" height="9" rx="2" fill="currentColor"/>
                                                    <rect opacity="0.3" x="13" y="13" width="9" height="9" rx="2" fill="currentColor"/>
                                                    <rect opacity="0.3" x="2" y="13" width="9" height="9" rx="2" fill="currentColor"/>
                                                </svg>
                                            </span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/list-layout-with-sidebar">
                                            <span class="svg-icon text-seegreen svg-icon-2hx">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M14 10V20C14 20.6 13.6 21 13 21H10C9.4 21 9 20.6 9 20V10C9 9.4 9.4 9 10 9H13C13.6 9 14 9.4 14 10ZM20 9H17C16.4 9 16 9.4 16 10V20C16 20.6 16.4 21 17 21H20C20.6 21 21 20.6 21 20V10C21 9.4 20.6 9 20 9Z" fill="currentColor"/>
                                                    <path d="M7 10V20C7 20.6 6.6 21 6 21H3C2.4 21 2 20.6 2 20V10C2 9.4 2.4 9 3 9H6C6.6 9 7 9.4 7 10ZM21 6V3C21 2.4 20.6 2 20 2H3C2.4 2 2 2.4 2 3V6C2 6.6 2.4 7 3 7H20C20.6 7 21 6.6 21 6Z" fill="currentColor"/>
                                                </svg>
                                            </span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div> -->

              <div
                class="col-lg-7 col-md-12 col-sm-12 order-lg-2 order-md-3 elco_bor col-sm-12"
              >
                <div class="shorting_pagination">
                  <div class="shorting_pagination_laft">
                    <h4>Showing 1-10 of {{ propertyData.length }} results</h4>
                  </div>
                  <!-- <div class="shorting_pagination_right">
                    <ul>
                      <li v-for="page in totalPages" :key="page">
                        <router-link to="" class="active">{{
                          page
                        }}</router-link>
                      </li> -->
                      <!-- <li><router-link to="">2</router-link></li>
                                            <li><router-link to="">3</router-link></li>
                                            <li><router-link to="">4</router-link></li>
                                            <li><router-link to="">5</router-link></li>
                                            <li><router-link to="">6</router-link></li> -->
                    <!-- </ul>
                  </div> -->
                </div>
              </div>

              <!-- <div
                class="col-lg-3 col-md-6 col-sm-12 order-lg-3 order-md-2 col-sm-6 pe-0"
              >
                <div class="shorting-right">
                  <label class="me-2">Short By:</label>
                  <div class="shorting-by border rounded">
                    <ShortBy />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="filter_search_opt">
              <router-link
                to=""
                class="btn btn-dark full-width mb-4"
                @click="show = !show"
              >
                <span class="svg-icon text-light svg-icon-2hx me-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z"
                      fill="currentColor"
                    />
                  </svg> </span
                >Open Filter Option
              </router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-md-12 col-sm-12">
            <div
              class="simple-sidebar sm-sidebar"
              :class="show ? 'd-block' : 'd-none d-lg-block'"
              id="filter_search"
              style="left: 0"
            >
              <div class="search-sidebar_header">
                <h4 class="ssh_heading">Close Filter</h4>
                <button
                  @click="show = !show"
                  class="w3-bar-item w3-button w3-large"
                >
                  <i class="fa-regular fa-circle-xmark fs-5 text-muted-2"></i>
                </button>
              </div>
              <PropertySidebarOne
                @update:selectedType="selectedType = $event"
                @update:selectedCity="selectedCity = $event"
                @update:selectedPtype="selectedPtype = $event"
                @update:selectedBed="selectedBed = $event"
                @update:maxPrice="maxPrice = $event"
              />
            </div>
          </div>

          <div class="col-lg-8 col-md-12 list-layout">
            <div class="row justify-content-center g-4">
              <div
                v-for="(item, index) in paginatedProperties"
                :key="item.id || index"
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12"
              >
                <ListLayoutTwo :item="item" border="border"/>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <ul class="pagination p-center">
                  <li class="page-item">
                    <router-link
                      class="page-link"
                      to="#"
                      aria-label="Previous"
                      @click.prevent="changePage(currentPage - 1)"
                    >
                      <i class="fa-solid fa-arrow-left-long"></i>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </li>

                  <!-- Page Numbers -->
                  <li
                    v-for="page in totalPages"
                    :key="page"
                    class="page-item"
                    :class="{ active: currentPage === page }"
                  >
                    <router-link
                      class="page-link"
                      to="#"
                      @click.prevent="changePage(page)"
                    >
                      {{ page }}
                    </router-link>
                  </li>
                  <!-- 

                  <li class="page-item active">
                    <router-link class="page-link" to="#">1</router-link>
                  </li>
                  <li class="page-item">
                    <router-link class="page-link" to="#">2</router-link>
                  </li>
                  <li class="page-item">
                    <router-link class="page-link" to="#">3</router-link>
                  </li>
                  <li class="page-item">
                    <router-link class="page-link" to="#">...</router-link>
                  </li> -->

                  <li class="page-item">
                    <router-link
                      class="page-link"
                      to="#"
                      aria-label="Next"
                      @click.prevent="changePage(currentPage + 1)"
                    >
                      <i class="fa-solid fa-arrow-right-long"></i>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <FooterTop :bg="'theme-bg'" /> -->

    <FooterDark />

    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, computed, watch } from "vue";
import NavbarDark from "@/components/navbar/navbar-dark.vue";
import PropertySidebarOne from "@/components/property/property-sidebar-one.vue";
// import ShortBy from "@/components/property/short-by.vue";
// import FooterTop from "@/components/footer/footer-top.vue";
import FooterDark from "@/components/footer/footer-dark.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";
import ListLayoutTwo from "@/components/property/list-layout-two.vue";

// import { propertyData } from '@/data/data';
import { useStore } from "vuex";
const store = useStore();

defineProps({
  border: Boolean,
  //   propertyData: {
  //     type: Array,
  //     required: true,
  //   },
});
const propertyData = ref([]);
const itemsPerPage = 10; // Number of properties per page
const currentPage = ref(1); // Current page number
const selectedType = ref(""); // Selected property type (buy/rent)
const selectedPtype=ref("")// Selected property type (apartment/house etc)
const selectedCity = ref(""); // Selected city
const maxPrice = ref(null); // Maximum price filter
const selectedBed = ref(""); // Selected number of bedrooms

// Filtered properties based on search criteria
const filteredProperties = computed(() => {
  return propertyData.value.filter((item) => {
    const matchesType =
      !selectedType.value ||
      (selectedType.value === "Sell" && item.tag2 === "For Sell") ||
      (selectedType.value === "Rent" && item.tag2 === "For Rent");

    const matchesCity =
      !selectedCity.value ||
      item.city.toLowerCase().includes(selectedCity.value.toLowerCase());

    const minimumPrice = maxPrice.value
      ? maxPrice.value.toString().split("-")[0]
      : 0;
    const maximumPrice = maxPrice.value
      ? maxPrice.value.toString().split("-")[1]
      : 1000000;

    const matchesPrice =
      !maxPrice.value ||
      (item.propertyValue <= maximumPrice &&
        item.propertyValue >= minimumPrice);

    const matchesPtype =
      !selectedPtype.value ||
      item.type.toLowerCase() === selectedPtype.value.toLowerCase();

    const matchesBed =
      !selectedBed.value ||
      parseInt(item.beds.split(" ")[0]) >= selectedBed.value;

    return (
      matchesType &&
      matchesCity &&
      matchesPrice &&
      matchesPtype &&
      matchesBed
    );
  });
});

onMounted(async () => {
  // Check if propertyData is empty and fetch data if needed
  if (store.getters["properties/properties"].length == 0) {
    await store.dispatch("properties/loadPropertiesfirebaseAdmin");
  }
  propertyData.value = await store.getters["properties/properties"];
  console.log("Property Data  from listlayoutnew3.vue:", propertyData.value);
});
const show = ref(false);

// Calculate total pages
const totalPages = computed(() => {
  return Math.ceil(filteredProperties.value.length / itemsPerPage);
});

// Get properties for the current page
const paginatedProperties = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return filteredProperties.value.slice(start, end);
});

//Change page
const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    window.scrollTo(0, 0); // Scroll to the top of the page
  }
};

// Watch for changes in filters and reset to the first page
watch([selectedType, selectedCity, maxPrice,selectedPtype,selectedBed], () => {
  currentPage.value = 1; // Reset to the first page when filters change
});
</script>
